/**
 * Timesheets Module
 */
(function(){
    'use strict';

    angular.module('elogbooks.user.timesheets', []);
})();